import EventBase from './EventBase'
import EventID from './EventID'

/**
 * 刷新UI画面消息类
 */

export default class EventFreshUI extends EventBase {
  /**
   * 刷新画面构造函数
   */
  constructor() {
    super()
    this.Parameter = ['']
  }
  /**
   * 事件ID
   */
  Code = EventID.FreshUI

  /**
   * 获取描述信息
   */
}
